module.exports = __webpack_public_path__ + "2ddb8d1352043ae3f4efae2998011d6f.png";